import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 px-6 bg-white border-y border-warm-200" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-16 text-center font-display" data-id="element-12">
          PARA QUIÉN ES (Y PARA QUIÉN NO)
        </h2>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-13">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-teal-50/50 p-8 rounded-2xl border border-teal-100" data-id="element-14">
            <h3 className="text-2xl font-bold text-teal-800 mb-8 flex items-center" data-id="element-15">
              <span className="bg-teal-100 p-2 rounded-full mr-3" data-id="element-16">
                <Check className="w-6 h-6 text-teal-700" data-id="element-17" />
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-18">
              {['estás cansada de decidir qué comer todos los días', 'quieres comer mejor sin convertirlo en identidad', 'te sirve lo simple, repetible y realista'].map((item, i) => <li key={i} className="flex items-start text-lg text-warm-900/80" data-id="element-19">
                  <Check className="w-5 h-5 text-teal-600 mt-1 mr-3 flex-shrink-0" data-id="element-20" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-warm-50 p-8 rounded-2xl border border-warm-200" data-id="element-21">
            <h3 className="text-2xl font-bold text-warm-700 mb-8 flex items-center" data-id="element-22">
              <span className="bg-warm-200 p-2 rounded-full mr-3" data-id="element-23">
                <X className="w-6 h-6 text-warm-600" data-id="element-24" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-25">
              {['buscas un plan médico o pérdida de peso garantizada', 'quieres recetas gourmet y cocinar diario', 'te da alergia repetir comidas (literalmente)'].map((item, i) => <li key={i} className="flex items-start text-lg text-warm-900/80" data-id="element-26">
                  <X className="w-5 h-5 text-warm-400 mt-1 mr-3 flex-shrink-0" data-id="element-27" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}